import styled, { css } from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { getLineHeight, getFontWeight } from './utils.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { spacing } from '../constants/spacing.js';

var fontFamilyStyles = /*#__PURE__*/css(["font-family:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.font.family;
});
var contentTextStyles = /*#__PURE__*/css(["", ";margin:0;line-height:", ";font-weight:", ";font-style:", ";"], fontFamilyStyles, function (p) {
  return getLineHeight({
    lineHeightMap: p.theme.contentText.web.lineHeights,
    lineHeight: p.$lineHeight
  });
}, getFontWeight, function (props) {
  return props.$italic ? 'italic' : 'normal';
});
var styledContentText = /*#__PURE__*/styled.p.withConfig(boxStyledOptions).withConfig({
  displayName: "stylesweb__styledContentText",
  componentId: "sc-zn37o3-0"
})(["", ";margin-bottom:", ";text-align:inherit;", ";line-height:", ";&:focus-visible{outline-offset:0;box-shadow:0 0 0px 4px ", ";outline:2px solid ", ";}"], contentTextStyles, function (props) {
  return props.$paragraph ? spacing.xxs : 0;
}, boxStyles, function (p) {
  return getLineHeight({
    lineHeightMap: p.theme.contentText.web.lineHeights,
    lineHeight: p.$lineHeight
  });
}, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
});

export { contentTextStyles, fontFamilyStyles, styledContentText };
